__turbopack_context__.v({
  "expandHeight": "product-trade-in-module-scss-module__oe_dwq__expandHeight",
  "icon": "product-trade-in-module-scss-module__oe_dwq__icon",
  "root": "product-trade-in-module-scss-module__oe_dwq__root",
  "text": "product-trade-in-module-scss-module__oe_dwq__text",
  "title": "product-trade-in-module-scss-module__oe_dwq__title",
});
